import { render, staticRenderFns } from "./UcelovaCastWrapper.vue?vue&type=template&id=d9d1cebe&scoped=true&"
import script from "./UcelovaCastWrapper.vue?vue&type=script&lang=js&"
export * from "./UcelovaCastWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d1cebe",
  null
  
)

export default component.exports